'use client'

import React, { useState } from 'react'
import ReviewsList from './ReviewsList'

interface Review {
  rating: number;
  name: string;
  comment: string;
}
export default function ProductReviews({ rating, total_rating, total_sold, avg_rate, review, translations }: { rating?: { [key: number]: number }, total_rating?: number, total_sold?: number, avg_rate?: number, review?: Review[], translations?: any }) {
  // Example data
  const totalReviews = total_rating || 0
  const verifiedBuyers = total_sold || 0
  const averageRating = avg_rate || 0
  const ratingsArray = rating
    ? [rating[1] || 0, rating[2] || 0, rating[3] || 0, rating[4] || 0, rating[5] || 0]
    : [0, 0, 0, 0, 0]

  const [reviewsOpen, setReviewsOpen] = useState(false)

  // sample review list (replace with real data when available)
  const sampleReviews = [
    { rating: 5, name: 'Radhika pandhare', comment: 'Amazing product' },
    { rating: 5, name: 'Jinia Pal', comment: "Gives a mild gel cast on drying, which breaks down easily with SOTC. Gives a medium hold to my hair. You don’t need a gel after applying this cream." },
  ]

  return (
    <>
      <div className="mt-4 border-t pt-4">
        <h2 className="text-lg md:text-xl font-bold mb-3 md:mb-4">{translations["cust_reviews"] || "Customer reviews"}</h2>
        <div className="flex md:flex-row items-center justify-between gap-5 border border-chart-2 shadow-[0px_4px_30px_0px_#0000000F] rounded-[10px] p-3">
          <div className="flex justify-center items-center px-2">
            <div className="flex flex-col items-center">
              <span className="text-4xl font-bold text-black flex items-center">
                {averageRating}
                <span className="text-yellow-500 text-3xl ml-1">★</span>
              </span>
              <button
                onClick={() => setReviewsOpen(true)}
                className="text-xs text-gray-600 mt-1 underline underline-offset-4 decoration-dotted hover:text-black"
                aria-label="Show verified buyer reviews"
              >
                {totalReviews} {translations["vrfd_buyers"] || "Verified buyers"}
              </button>
            </div>
          </div>

          <div className="flex-1 md:w-1/3 flex flex-col gap-1 ">
            {[1, 2, 3, 4, 5].map((star) => (
              <div key={star} className="flex items-center gap-2">
                <span className="text-sm font-medium">{star}</span>
                <span className="text-yellow-500 text-base">★</span>
                <div className="flex-1 h-1 rounded bg-gray-200 overflow-hidden">
                  <div
                    className={`h-1 rounded ${star === 5 ? 'bg-primary' : 'bg-yellow-400'}`}
                    style={{
                      width: `${ratingsArray[star - 1] && totalReviews ? (ratingsArray[star - 1] / totalReviews) * 100 : 0}%`,
                      transition: 'width 0.3s'
                    }}
                  />
                </div>
                <span className="text-xs text-gray-700 w-11 text-center">{ratingsArray[star - 1]} </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <ReviewsList open={reviewsOpen} onClose={() => setReviewsOpen(false)} reviews={review} translations={translations} />
    </>
  )
}